import { AnalyticsTypes } from '@zocdoc-frontend-common/utils-react';
import { PHONE_VERIFICATION_GA_CATEGORY, GaActionText } from './constants';
import { AbGoals } from './utils';

const apiHost =
    process.env.JEST_API_HOST || process.env.STORYBOOK_SIGN_IN_API_HOST || '';

export const PinVerificationErrors = {
    INVALID_PIN: 'INVALID_PIN',
    TOO_MANY_ATTEMPTS: 'TOO_MANY_ATTEMPTS',
    SOMETHING_WENT_WRONG: 'SOMETHING_WENT_WRONG',
};

const CHANGE_PHONE_NUMBER = '@@phoneverification/CHANGE_PHONE_NUMBER';
const SENDING_PIN = '@@phoneverification/SENDING_PIN';
const SENDING_PIN_SUCCESS = '@@phoneverification/SENDING_PIN_SUCCESS';
const SENDING_PIN_FAILURE = '@@phoneverification/SENDING_PIN_FAILURE';
const NO_VERIFICATION_NEEDED = '@@phoneverification/NO_VERIFICATION_NEEDED';
const EDIT_PHONE_NUMBER = '@@phoneverification/EDIT_PHONE_NUMBER';
const CHANGE_PIN = '@@phoneverification/CHANGE_PIN';
const VERIFYING_PIN = '@@phoneverification/VERIFYING_PIN';
const VERIFY_PIN_SUCCESS = '@@phoneverification/VERIFY_PIN_SUCCESS';
const VERIFY_PIN_FAILURE = '@@phoneverification/VERIFY_PIN_FAILURE';
const RESET = '@@phoneverification/RESET';

const TRACK_SELECT_PHONE_NUMBER =
    '@@phoneverification/TRACK_SELECT_PHONE_NUMBER';
const TRACK_CLICK_TEXT_ME = '@@phoneverification/TRACK_CLICK_TEXT_ME';
const TRACK_CLICK_CALL_ME = '@@phoneverification/TRACK_CLICK_CALL_ME';
const TRACK_SELECT_PIN = '@@phoneverification/TRACK_SELECT_PIN';
const TRACK_CLICK_VERIFY_PIN = '@@phoneverification/TRACK_CLICK_VERIFY_PIN';
const TRACK_CLICK_EDIT_PHONE_NUMBER =
    '@@phoneverification/TRACK_CLICK_EDIT_PHONE_NUMBER';
const TRACK_CLICK_LETS_TRY_THIS_AGAIN =
    '@@phoneverification/TRACK_CLICK_LETS_TRY_THIS_AGAIN';

export const PhoneVerificationPageActions = {
    CHANGE_PHONE_NUMBER,
    SENDING_PIN,
    SENDING_PIN_SUCCESS,
    SENDING_PIN_FAILURE,
    NO_VERIFICATION_NEEDED,
    EDIT_PHONE_NUMBER,
    CHANGE_PIN,
    VERIFYING_PIN,
    VERIFY_PIN_SUCCESS,
    VERIFY_PIN_FAILURE,
    RESET,
    TRACK_SELECT_PHONE_NUMBER,
    TRACK_CLICK_TEXT_ME,
    TRACK_CLICK_CALL_ME,
    TRACK_SELECT_PIN,
    TRACK_CLICK_VERIFY_PIN,
    TRACK_CLICK_EDIT_PHONE_NUMBER,
    TRACK_CLICK_LETS_TRY_THIS_AGAIN,
};

export const changePhoneNumber = (phoneNumber) => ({
    type: PhoneVerificationPageActions.CHANGE_PHONE_NUMBER,
    phoneNumber,
});

export const sendingPin = () => ({
    type: PhoneVerificationPageActions.SENDING_PIN,
});

export const sendingPinSuccess = (bannerErrorMessage) => ({
    bannerErrorMessage,
    type: PhoneVerificationPageActions.SENDING_PIN_SUCCESS,
    _abGoal: AbGoals.MadeItToPin,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: PHONE_VERIFICATION_GA_CATEGORY,
            action: GaActionText.madeItToPin,
        },
    },
});

export const sendingPinFailure = (error) => ({
    type: PhoneVerificationPageActions.SENDING_PIN_FAILURE,
    error,
});

export const noVerificationNeeded = () => ({
    type: PhoneVerificationPageActions.NO_VERIFICATION_NEEDED,
});

export const editPhoneNumber = () => ({
    type: PhoneVerificationPageActions.EDIT_PHONE_NUMBER,
});

export const changePin = (pin) => ({
    type: PhoneVerificationPageActions.CHANGE_PIN,
    pin,
});

export const verifyingPin = () => ({
    type: PhoneVerificationPageActions.VERIFYING_PIN,
});

export const verifyPinSuccess = () => ({
    type: PhoneVerificationPageActions.VERIFY_PIN_SUCCESS,
});

export const verifyPinFailure = (error) => ({
    type: PhoneVerificationPageActions.VERIFY_PIN_FAILURE,
    error,
});

export const reset = () => ({
    type: PhoneVerificationPageActions.RESET,
});

const changePhoneNumberEndpoint = `${apiHost}/api/web/2/phone/`;
const verifyEndpoint = `${apiHost}/api/web/2/phone/verify`;

function phoneNumberChange(phoneNumber, serviceType) {
    return (dispatch) => {
        if (!phoneNumber || phoneNumber.length < 1) {
            dispatch(sendingPinFailure(''));
            return;
        }

        dispatch(sendingPin());

        let responseStatus;
        return fetch(changePhoneNumberEndpoint, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            credentials: 'include',
            body: `PhoneNumber=${encodeURIComponent(
                phoneNumber
            )}&ServiceType=${encodeURIComponent(serviceType)}&PhoneType=cell`,
        })
            .then((response) => {
                responseStatus = response.status;
                if (responseStatus === 200) {
                    return response.json().then((body) => {
                        if (body.error) {
                            dispatch(sendingPinFailure(body.error.message));
                        } else if (body.data && body.data.sent_pin) {
                            dispatch(
                                sendingPinSuccess(
                                    body.data.banner_error_message
                                )
                            );
                        } else {
                            dispatch(noVerificationNeeded());
                        }
                    });
                } else {
                    return response.json().then((body) => {
                        if (body.error && body.error.fields.length > 0) {
                            const phoneError = body.error.fields.find(
                                (error) => error.name === 'PhoneNumber'
                            );
                            dispatch(sendingPinFailure(phoneError.message));
                        } else {
                            dispatch(sendingPinFailure(null));
                        }
                    });
                }
            })
            .catch(() => {
                dispatch(sendingPinFailure());
            });
    };
}

export function textMe(phoneNumber) {
    return phoneNumberChange(phoneNumber, 'Sms');
}

export function callMe(phoneNumber) {
    return phoneNumberChange(phoneNumber, 'Phone');
}

export function verifyPin(pin) {
    return (dispatch) => {
        if (!pin) {
            dispatch(verifyPinFailure());
        }

        dispatch(verifyingPin());

        let responseStatus;
        return fetch(verifyEndpoint, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                Pin: pin,
            }),
            credentials: 'include',
        })
            .then((response) => {
                responseStatus = response.status;
                if (responseStatus === 200) {
                    dispatch(verifyPinSuccess());
                } else if (responseStatus === 400) {
                    return response.json().then((body) => {
                        if (
                            body.error.fields[0].message === 'Too many attempts'
                        ) {
                            dispatch(
                                verifyPinFailure(
                                    PinVerificationErrors.TOO_MANY_ATTEMPTS
                                )
                            );
                        } else {
                            dispatch(
                                verifyPinFailure(
                                    PinVerificationErrors.INVALID_PIN
                                )
                            );
                        }
                    });
                } else {
                    dispatch(
                        verifyPinFailure(
                            PinVerificationErrors.SOMETHING_WENT_WRONG
                        )
                    );
                }
            })
            .catch(() => {
                dispatch(
                    verifyPinFailure(PinVerificationErrors.SOMETHING_WENT_WRONG)
                );
            });
    };
}

export const trackSelectPhoneNumber = () => ({
    type: TRACK_SELECT_PHONE_NUMBER,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: PHONE_VERIFICATION_GA_CATEGORY,
            action: GaActionText.selectPhoneNumber,
        },
    },
});

export const trackClickTextMe = () => ({
    type: TRACK_CLICK_TEXT_ME,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: PHONE_VERIFICATION_GA_CATEGORY,
            action: GaActionText.clickTextMe,
        },
    },
});

export const trackClickCallMe = () => ({
    type: TRACK_CLICK_CALL_ME,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: PHONE_VERIFICATION_GA_CATEGORY,
            action: GaActionText.clickCallMe,
        },
    },
});

export const trackSelectPin = () => ({
    type: TRACK_SELECT_PIN,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: PHONE_VERIFICATION_GA_CATEGORY,
            action: GaActionText.selectPin,
        },
    },
});

export const trackClickVerifyPin = () => ({
    type: TRACK_CLICK_VERIFY_PIN,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: PHONE_VERIFICATION_GA_CATEGORY,
            action: GaActionText.clickVerifyPin,
        },
    },
});

export const trackClickEditPhoneNumber = () => ({
    type: TRACK_CLICK_EDIT_PHONE_NUMBER,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: PHONE_VERIFICATION_GA_CATEGORY,
            action: GaActionText.clickEditPhoneNumber,
        },
    },
});

export const trackClickLetsTryThisAgain = () => ({
    type: TRACK_CLICK_LETS_TRY_THIS_AGAIN,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: PHONE_VERIFICATION_GA_CATEGORY,
            action: GaActionText.clickLetsTryThisAgain,
        },
    },
});

export const PhoneVerificationPageActionCreators = {
    trackSelectPhoneNumber,
    trackClickTextMe,
    trackClickCallMe,
    trackSelectPin,
    trackClickVerifyPin,
    trackClickEditPhoneNumber,
    trackClickLetsTryThisAgain,
};
